import React, { useState } from "react";

import TagMeetingHeader from "../components/TagMeetingHeader";
import UserFormComponent from "../components/UserFormComponent";
import ThankYouComponent from "../components/ThankYouComponent";

const CreateUserPage = () => {
  const [showSuccess, setShowSuccess] = useState(false);

  return (
    <>
      <TagMeetingHeader headerName="User Form" />
      {showSuccess ? (
        <ThankYouComponent message="User has been created successfully!" />
      ) : (
        <UserFormComponent setShowSuccess={setShowSuccess} />
      )}
    </>
  );
};

export default CreateUserPage;
